import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    displayName: 'no-future-terms-modal',

    propTypes: {
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
    },

    getInitialState() {
        return {
            show: false,
        };
    },

    promise: null,
    resolve: null,
    reject: null,

    show() {
        this.setState({ show: true });
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        return this.promise;
    },

    onClose() {
        this.resolve();
        this.setState({ show: false });
    },

    render() {
        const subjectBid = this.props.subject.get('bid');
        const message = (
            <p key="message">
                You are trying to set a goal for the next academic year, but that year is not set up in MAP. Ask a
                leader to add the next year within the MAP preferences.
            </p>
        );
        const buttons = [
            <Button
                key="close-button"
                id={`no-future-terms-close-button-${subjectBid}`}
                bsClass="ok-button btn"
                onClick={this.onClose}
            >
                close
            </Button>,
        ];

        return (
            <Modal
                id={`no-future-terms-modal-${subjectBid}`}
                bsSize="lg"
                aria-labelledby="no-future-terms"
                onHide={this.onClose}
                bsClass="growth-goal-modal modal"
                show={this.state.show}
            >
                <Modal.Header key="header" closeButton={true}>
                    <Modal.Title>Setting Goals</Modal.Title>
                </Modal.Header>
                <Modal.Body key="body">{message}</Modal.Body>
                <Modal.Footer>{buttons}</Modal.Footer>
            </Modal>
        );
    },
});
